<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>
import store from '@/core/store'
import { actionTypes, mutationTypes, routesNames } from '@/core/constants'

const deveRedirecionarParaVisaoSolicitante = (routeName) => {
	return (
		routeName !== routesNames.ADESAO.ADERENTE.ADESAO_ITENS &&
		routeName !== routesNames.ADESAO.ADERENTE.ADESAO_DOCUMENTOS &&
		routeName !== routesNames.ADESAO.ACESSAR_OCORRENCIAS_VIEW &&
		routeName !== routesNames.ADESAO.ACESSAR_LINHA_DO_TEMPO_VIEW
	)
}

const buscarAdesao = async (to, from, next) => {
	let retorno = await store.dispatch(actionTypes.ADESAO.BUSCAR_TIPO_VISUALIZACAO, to.params.id)

	let adesao = await store.dispatch(actionTypes.ADESAO.BUSCAR_POR_ID, to.params.id)
	store.commit(mutationTypes.ADESAO.SET_INFORMACOES_ADESAO, adesao)

	if (deveRedirecionarParaVisaoSolicitante(to.name)) {
		next({
			name: routesNames.ADESAO.ADERENTE.ADESAO_VIEW,
			params: { id: to.params.id, tipoAcesso: retorno.tipoVisualizacao },
		})
	} else {
		next()
	}
}

export default {
	name: 'adesao-view',
	beforeRouteEnter: buscarAdesao,
}
</script>
